<template>
    <el-row class="container">
        <HeaderComponent></HeaderComponent>
        <el-col :span="24" class="main">
            <SidebarComponent></SidebarComponent>
            <section class="content-container">
                <div class="grid-content bg-purple-light">
                    <el-col :span="24" class="breadcrumb-container" v-if="showBreadcrumbs">
                        <strong class="title">{{ $route.name }}</strong>
                        <el-breadcrumb separator="/" class="breadcrumb-inner">
                            <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
                                {{ item.name }}
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                    </el-col>
                    <el-col :span="24" class="content-wrapper">
                        <transition name="fade" mode="out-in">
                            <router-view :key="$route.fullPath"></router-view>
                        </transition>
                    </el-col>
                </div>
            </section>
        </el-col>
    </el-row>
</template>

<script>
    import HeaderComponent from '@/components/HeaderComponent'
    import SidebarComponent from '@/components/SidebarComponent'

    export default {
        data () {
            return {
				showBreadcrumbs: false
            }
        },
        created () {
            this.$store.dispatch('fetchStages')
            this.$store.dispatch('fetchEditions')
        },
        methods: {},
        components: {
            HeaderComponent,
            SidebarComponent
        }
    }

</script>

<style scoped lang="scss">
    .container {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
        .main {
            display: flex;
            position: absolute;
            /*top: 60px;*/
            /*bottom: 0px;*/
            /*overflow: hidden;*/
            min-height: 100vh;
            background: #F3F3F4;
            .content-container {
                flex: 1;
                overflow-y: scroll;
                padding: 30px 30px;
                .breadcrumb-container {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    line-height: 30px;
                    margin-bottom: 24px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Home.vue?7e6a513a